module.exports = __webpack_public_path__ + "img/lead-other.07711e55.svg";